export const SHIFT_HELP_DOMAIN = "shift" as const;

export const SHIFT_HELP_SCREENS = {
  page: "shift.page",
  schedule: "shift.schedule",
  manage: "shift.manage",
  coverage: "shift.coverage",
  form: "shift.form",
} as const;

export const SHIFT_PAGE_HELP_KEYS = {
  tabs: "shift.page.tabs",
} as const;

export const SHIFT_SCHEDULE_HELP_KEYS = {
  search: "shift.schedule.search",
  filters: "shift.schedule.filters",
  view: "shift.schedule.view",
  create: "shift.schedule.create",
  calendar: "shift.schedule.calendar",
} as const;

export const SHIFT_MANAGE_HELP_KEYS = {
  search: "shift.manage.search",
  filters: "shift.manage.filters",
  rows: "shift.manage.rows",
  row: "shift.manage.row",
} as const;

export const SHIFT_COVERAGE_HELP_KEYS = {
  officer: "shift.coverage.officer",
  property: "shift.coverage.property",
  map: "shift.coverage.map",
  officers: "shift.coverage.officers",
} as const;

export const SHIFT_FORM_HELP_KEYS = {
  type: "shift.form.type",
  property: "shift.form.property",
  officer: "shift.form.officer",
  fromDate: "shift.form.from_date",
  toDate: "shift.form.to_date",
  presets: "shift.form.presets",
  days: "shift.form.days",
  breaks: "shift.form.breaks",
  notes: "shift.form.notes",
  submit: "shift.form.submit",
} as const;

export const SHIFT_HELP_TOURS = {
  scheduleIntro: "shift.schedule.intro",
  manageIntro: "shift.manage.intro",
  coverageIntro: "shift.coverage.intro",
  formCreate: "shift.form.create",
} as const;
